module.exports = __webpack_public_path__ + "static/img/yy21.bbb597d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy21.png
// module id = NzL1
// module chunks = 1